const reportedErrors = new WeakSet<object>();

/** Marks an error we sent to NR ourselves, so NR's error handler never filters it out. */
export const markReportedError = (error: object): void => {
  reportedErrors.add(error);
};

export const isReportedError = (error: unknown): boolean => typeof error === 'object' && error !== null && reportedErrors.has(error);
